import { autoinject } from "aurelia-framework";
import { RequestClientService } from "./request-client.service";
import { ConfigService } from "./config.service";

@autoinject()
export class SearchHistoryClientService {

    constructor(private requestClient: RequestClientService, private configService: ConfigService) { }

    public saveSearchHistoryItem(model: any) {
        const request = {
            entry: {
                entityUri: model.selectedEntityUri,
                entityId: model.selectedEntity.id,
                searchDate: new Date()
            }
        }
        this.requestClient.post(this.configService.config.urls.rightShipPlatformApiUrl + '/api/v1/SearchHistoryApi/saveSearchResult', null, request);
    }
}
